<template lang="pug">
  footer.footer(v-if="footer")
    .page__wr
      .footer__top
        .footer__left
          router-link.footer__logo-wr(to="/")
            img.footer__logo(v-if="footer.logo", :src="footer.logo", alt = '')
          .footer__socials(v-if="footer.socials")
            a.footer__socials-item(v-for="item in footer.socials", :href="item.link", :key="item.id", target="_blank")
              SvgIcon.footer__socials-item-ico(:name="item.icon", width="40", height="40")
        .footer__center
          .footer__menu(v-if="footer.menu")
            router-link.footer__menu-item(v-for="item in footer.menu", :to="item.link", :key="item.id")
              | {{item.title}}
        .footer__right
          .footer__right-item(v-if="footer.phone")
            a.footer__right-item-link.footer__right-item-link--bold(:href="footer.phone.link") {{footer.phone.title}}
            SvgIcon.footer__right-item-arrow(v-if="footer.phone.items", name="arrow", width="16", height="16")
            .footer__right-item-popup(v-if="footer.phone.items")
              a.footer__right-item-popup-link(v-for="item in footer.phone.items", :href="item.link") {{item.title}}
          .footer__right-item(v-if="footer.time")
            SvgIcon.footer__right-item-ico(name="clock", width="16", height="16")
            .footer__right-item-text {{footer.time}}
          .footer__right-item(v-if="footer.address")
            SvgIcon.footer__right-item-ico(name="marker", width="16", height="16")
            .footer__right-item-text {{footer.address}}
          .footer__right-item(v-if="footer.email")
            SvgIcon.footer__right-item-ico(name="mail", width="16", height="16")
            a.footer__right-item-link(:href="footer.email.link") {{footer.email.title}}
      .footer__bottom
        .footer__copy {{footer.copy}}
        Samedia
</template>

<script>
  import '@/components/common/footer/footer.styl';

  import EventBus from '@/eventBus';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Samedia from '@/components/common/samedia/Samedia';

  export default {
    name: 'Footer',

    data() {
      return {
        footer: null
      }
    },

    components: {
      SvgIcon,
      Samedia
    },

    created() {
      // Данные страницы загружены
      EventBus.$on('pageLoaded', res => {
        this.footer = res.footer;
      });

      this.$nextTick(() => {
        this.initScripts();
      });
    },

    methods: {
      initScripts() {
        $(document).on('click', '.footer__right-item-arrow', function() {
          $('.footer__right-item-popup').toggleClass('footer__right-item-popup--show');
          $('.footer__right-item-arrow').toggleClass('footer__right-item-arrow--rotate');
        });

        $(document).on('click', function(e) {
          if(!$(e.target).is('.footer__right-item, .footer__right-item *')) {
            $('.footer__right-item-popup').removeClass('footer__right-item-popup--show');
            $('.footer__right-item-arrow').removeClass('footer__right-item-arrow--rotate');
          }
        });
      }
    }

  }
</script>
